// Reply in thread action builder.
//
// Wiring for the thread panel itself lives in #1301; for now the
// host row forwards the click to whatever handler it's been given.

import { Reply } from "lucide-react";

import type { MessageAction } from "~/components/MessageActions";

export function buildReplyAction(params: { onClick: () => void }): MessageAction {
  return {
    id: "reply",
    label: "Reply in thread",
    icon: Reply,
    onClick: params.onClick,
  };
}
